import React, { Component } from 'react';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class DefaultLocationForm extends Component {
    constructor(props) {
        super(props);
        this.onSave = () => {
            const { name, address } = this.state;
            this.props.onSave({ name, address });
        };
        this.handleFieldChange = (field) => (value) => {
            this.setState({ [field]: value });
        };
        this.handleAddressChange = (item) => {
            const { address } = item;
            this.setState({ address });
        };
        const details = props.details || {};
        this.state = {
            name: details.name || '',
            address: details.address || '',
        };
    }
    render() {
        const { address, name } = this.state;
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("h4", { className: "mt-0 mb-4 text-grey-darker" }, this.props.title),
            React.createElement("div", { className: "userDefaultOrigin grid sm:grid-cols-1 sm:gap-y-6 sm:gap-x-4" },
                React.createElement(CargomaticInput, { className: "sm:col-span-full", label: t('NAME'), info: t('NAME_OF_LOCATION'), value: name, onChange: this.handleFieldChange('name'), maxLength: 50 }),
                React.createElement(CargomaticInput, { className: "sm:col-span-full", type: "location", label: titleize(t('ADDRESS')), info: t('ADDRESS_FOR_LOCATION'), value: address, onSelect: this.handleAddressChange }),
                React.createElement("div", { className: "form-actions" },
                    React.createElement("button", { type: "button", className: "button button-green", onClick: this.onSave }, titleize(t('SAVE')))))));
    }
}
export default withTranslation()(DefaultLocationForm);
